import fetchOld from '../js/fetchToken'

const fetch = (data, autoGetToken = false) => {
  if (!autoGetToken) {
    return fetchOld(data)
  } else {
    if (!data.data) {
      data.data = {};
    }
    if (!data.params) {
      data.params = {}
    }
    data.params.token = JSON.parse(localStorage.getItem('userInfo')).token;
    data.data.token = JSON.parse(localStorage.getItem('userInfo')).token;
    return fetchOld(data)
  }
}

// 获取邮箱验证码接口
export const sendCode = (data) => {
	return fetch({
		method: 'post',
		url: '/biz/common/sendCode',
		data: data
	})
}

// 邮箱验证码密码注册接口
export const mallRegister = (data) => {
	return fetch({
		method: 'post',
		url: '/mallRegister',
		data: data
	})
}

// 表单提交
export const saveBaoMing = (data) => {
	return fetch({
		method: 'post',
		url: '/uc/tenant/saveBaoMing',
		data: data
	})
}